import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

interface VoicemailFilterProps {
  filterIndex: number;
}

/** Renders radio buttons for filtering sessions by voicemail detection */
export const VoicemailFilter = ({ filterIndex }: VoicemailFilterProps) => {
  const { t } = useTranslation();
  const { getValues, control } = useFormContext();

  const { update } = useFieldArray({ control, name: 'filters' });

  const hasVoicemail = useWatch({ control, name: `filters.${filterIndex}.hasVoicemail` });

  const handleChange = (value: string) => {
    let booleanValue: boolean | null;
    if (value === 'true') {
      booleanValue = true;
    } else if (value === 'false') {
      booleanValue = false;
    } else {
      booleanValue = null;
    }
    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, hasVoicemail: booleanValue });
  };

  return (
    <div className="space-y-3">
      <RadioGroup
        value={hasVoicemail?.toString() || ''}
        onValueChange={handleChange}
        className="gap-0"
      >
        <div className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-selected-soft">
          <RadioGroupItem value="true" id={`voicemail-true-${filterIndex}`} />
          <Label htmlFor={`voicemail-true-${filterIndex}`} className="cursor-pointer font-normal">
            {t('brain_logs.filters.voicemail.detected')}
          </Label>
        </div>
        <div className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-selected-soft">
          <RadioGroupItem value="false" id={`voicemail-false-${filterIndex}`} />
          <Label htmlFor={`voicemail-false-${filterIndex}`} className="cursor-pointer font-normal">
            {t('brain_logs.filters.voicemail.not_detected')}
          </Label>
        </div>
      </RadioGroup>
    </div>
  );
};
